// @ts-check

/** @file Defines the local Project shell and associations. */

import ProjectBase from "../model-bases/project.js"
import localDatabaseModel from "../database/local-database-model.js"

/** Project row in the local application replica. */
const ProjectModel = localDatabaseModel(ProjectBase)

export default ProjectModel
